<template>
    <footer>
        <div class="footer-1">
            <div class="container">
                <div class="row">
                    <div class="col-md-3 col-sm-6 col-12">
                        <router-link to="/">
                            <img src="/static/img/logos/logo-ibdi.jpg" style="width: 150px;" id="footer_logo" alt="logo">
                        </router-link>
                        <p class="mt-20">
                            Experte en développement d'entreprise et en intermédiation, IBDI est une société à responsabilité limitée (SARL) qui regroupe en son sein des experts dans différents domaines d'activités.
                        </p>
                        <ul class="social-links-footer">
                            <li><a href="#"><i class="fab fa-facebook"></i></a></li>
                            <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                            <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                            <li><a href="#"><i class="fab fa-linkedin"></i></a></li>
                        </ul>
                    </div>
                    <div class="col-md-3 col-sm-6 col-12">
                        <h2>Nos services</h2>
                        <div class="row mt-25">
                            <div class="col-md-12">
                                <ul class="footer-nav">
                                    <li v-for="(service, key) in services" :key="key">
                                        <a :href="'/service/' + service.slug">
                                            {{ service.name }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-12">
                        <h2>Nos récents produits</h2>
                        <div class="row mt-25">
                            <div class="col-md-12">
                                <ul class="footer-nav">
                                    <li v-for="(product, key) in products" :key="key">
                                        <a :href="'/produit/' + product.slug">
                                            {{ product.name }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-12">
                        <h2>Contacts</h2>
                        <div class="row mt-25">
                            <div class="col-md-12">
                                <ul class="footer-nav" v-if="infos != null">
                                    <li>
                                        <a href="javascript:void(0);">
                                            <i class="fas fa-phone"></i> {{ infos[2].value }}
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);">
                                            <i class="fas fa-map-marker-alt"></i> {{ infos[1].value }}
                                        </a>
                                    </li>
                                    <li>
                                        <a :href="'mailto:' + infos[0].value">
                                            <i class="fa fa-envelope"></i> {{ infos[0].value }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer-1-bar">
                    <p>IBDI © 2020. Tous droits réservés. Make by <a href="https://theitduck.github.io" style="color:#fff;">the_itduck</a></p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import { BASE_URL, API_PREFIX, API_VERSION } from '../../config/urls'
export default {
  name: 'Footer',
  data () {
    return {
      services: null,
      infos: null,
      products: null
    }
  },
  mounted () {
    this.getServices()
    this.getInfos()
    this.getProducts()
  },
  methods: {
    getServices () {
      let url = BASE_URL + API_PREFIX + API_VERSION + '/services'
      this.$http.get(url)
        .then((response) => {
          this.services = response.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getInfos () {
      let url = BASE_URL + API_PREFIX + API_VERSION + '/infos'
      this.$http.get(url)
        .then((response) => {
          this.infos = response.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getProducts () {
      let url = BASE_URL + API_PREFIX + API_VERSION + '/products'
      this.$http.get(url)
        .then((response) => {
          this.products = response.data.slice(0, 5)
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Footer.vue